import { render, staticRenderFns } from "./cabinet-profile.vue?vue&type=template&id=a77a9e8a&scoped=true"
import script from "./cabinet-profile.vue?vue&type=script&lang=js"
export * from "./cabinet-profile.vue?vue&type=script&lang=js"
import style0 from "./cabinet-profile.vue?vue&type=style&index=0&id=a77a9e8a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77a9e8a",
  null
  
)

export default component.exports